import { Mapper } from "../../../../base/utils/mapper";
import { DataBasicAttentionModel } from "../../../../domain/models/consult/data-basic-atenttion.model";
import { DataBasicAttentionEntity } from "../entities/data-basic-atenttion.entity";


export class DataBasicAttentionImplementationRepositoryMapper extends Mapper<DataBasicAttentionEntity, DataBasicAttentionModel> {
    mapFrom(param: DataBasicAttentionEntity): DataBasicAttentionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DataBasicAttentionModel): DataBasicAttentionEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}